











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Enums
import { RevenueRecognitionOptionsMap } from "@/data/product";

// Types
import { IProduct } from "@/models/products";
import { RevenueRecognitionOptions as RROptions } from "@/data/enums/products";

@Component
export default class RevenueRecognitionField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IProduct["accounting_revenue_recognition"];

  @Prop({ required: true })
  public brandValue!: IProduct["accounting_revenue_recognition"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data
  public hasBrandValue = true;
  public recognitionValue: IProduct["accounting_revenue_recognition"] =
    RROptions.INHERIT;
  public revenueRecognitionOptions = RevenueRecognitionOptionsMap();

  public onHasBrandValueChange() {
    if (this.brandValue === RROptions.INHERIT)
      this.recognitionValue = this.brandValue;
    this.onRecognitionValueChange();
  }

  // Watchers

  @Watch("recognitionValue")
  public onRecognitionValueChange() {
    this.$emit(
      "input",
      this.hasBrandValue ? RROptions.INHERIT : this.recognitionValue
    );
  }

  @Watch("value", { immediate: true })
  public onPassedValueChange() {
    this.hasBrandValue = !this.value;
    this.recognitionValue = this.hasBrandValue ? this.brandValue : this.value;
  }
}
